import { FormDataType } from './types';

export const MAPPING_VALUES = [
  { value: 'value', displayValue: 'Идентификатор' },
  { value: 'display', displayValue: 'Отображаемое значение' },
];

export const INIT_DATA: FormDataType = {
  value: 'muid',
  display: 'name',
};
